import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _, { isEmpty } from 'underscore';
import { MessageBar } from '@fluentui/react-message-bar';
import { isValidUrl } from '@bingads-webui/url-util';
import { SearchFilled } from '@fluentui/react-icons';
import { makeStyles, Input, shorthands } from '@fluentui/react-components';
import { VideoLoadPreview } from './video-load-preview';

const UrlInputMaxLen = 2048;
const EnterKeycode = 13;

const useStyles = makeStyles({
  helpLink: {
    color: '#337ab7',
    ...shorthands.textDecoration('underline'),
    fontWeight: 'normal',
    backgroundColor: 'transparent',
    ...shorthands.borderRadius('0px', '0px', '0px', '0px'),
    ...shorthands.border('none'),
  },
  container: {
    marginTop: '16px',
    lineHeight: '20px',
  },
  addUrlInput: {
    marginTop: '16px',
    width: '300px',
  },
  placeHolderImage: {
    position: 'absolute',
    right: '380px',
    top: '300px',
  },
  errorMesBelowUrlInput: {
    marginTop: '6px',
    color: '#A80000',
  },
  videoPlaybackView: {
    marginTop: '16px',
  },
  messageContainer: {
    bottom: '65px',
    position: 'absolute',
    left: '0px',
  },
});

const placeholderImage =
  "data:image/svg+xml,%3Csvg width='283' height='208' viewBox='0 0 283 208' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d_725_95734)'%3E%3Cpath d='M70.5224 137.244H227.751C229.828 137.244 231.443 135.647 231.443 133.592V40.9266C231.443 38.8725 229.828 37.2748 227.751 37.2748H70.5224C68.446 37.2748 66.8311 38.8725 66.8311 40.9266V133.592C66.8311 135.647 68.5614 137.244 70.5224 137.244Z' fill='%2328C2D1'/%3E%3C/g%3E%3Cpath d='M87.7524 127.473H210.52C212.141 127.473 213.402 126.464 213.402 125.166V66.6407C213.402 65.3433 212.141 64.3342 210.52 64.3342H87.7524C86.1311 64.3342 84.8701 65.3433 84.8701 66.6407V125.166C84.8701 126.464 86.2212 127.473 87.7524 127.473Z' fill='%23EFEFEF'/%3E%3Cpath d='M231.667 40.3377L67.0303 40.2814L67.0038 55.6503L231.641 55.7066L231.667 40.3377Z' fill='%232B88D8'/%3E%3Cpath d='M219.951 46.3243L95.4434 46.2837L95.4373 49.6655L219.945 49.7061L219.951 46.3243Z' fill='%23EFEFEF'/%3E%3Cpath d='M79.4756 43.7731C79.4748 43.7731 79.4741 43.7732 79.4726 43.7733C79.4718 43.7734 79.4718 43.7734 79.471 43.7735C79.4695 43.7736 79.4688 43.7737 79.4673 43.7739C76.9794 43.7764 74.9626 45.7928 74.9606 48.2811C74.9586 50.7701 76.973 52.7894 79.4601 52.7954C79.4616 52.7952 79.4625 52.7959 79.464 52.7958C79.4647 52.7957 79.4647 52.7957 79.4655 52.7956C79.4663 52.7956 79.467 52.7955 79.4685 52.7953C81.9598 52.7971 83.9811 50.7795 83.9829 48.2881C83.9853 45.796 81.9669 43.7748 79.4756 43.7731ZM79.4662 52.1444C79.4655 52.1445 79.4639 52.1447 79.4632 52.1447C78.9887 52.1421 78.3591 51.3349 78.0565 49.9787L80.8781 49.9811C80.5724 51.337 79.9411 52.144 79.4662 52.1444ZM77.9424 49.328C77.9006 49.0019 77.8779 48.6525 77.8778 48.2825C77.8778 47.9064 77.903 47.5524 77.9457 47.2218L80.9909 47.2238C81.0339 47.5536 81.0578 47.9083 81.057 48.2845C81.0565 48.6553 81.0331 49.0038 80.9914 49.3296L77.9424 49.328ZM75.6117 48.281C75.6118 47.9133 75.6652 47.558 75.7617 47.2207L77.2916 47.2222C77.2505 47.5625 77.2285 47.917 77.2282 48.2824C77.2281 48.6425 77.2492 48.992 77.2882 49.3283L75.7553 49.3272C75.6622 48.9939 75.6111 48.6434 75.6117 48.281ZM79.4687 44.4233C79.4694 44.4233 79.4709 44.4231 79.4717 44.423C79.9445 44.4243 80.5721 45.2263 80.8761 46.574L78.0615 46.5717C78.3681 45.2256 78.9963 44.4258 79.4687 44.4233ZM81.646 47.2249L83.1843 47.2263C83.2809 47.5639 83.3333 47.9196 83.3332 48.2873C83.3326 48.6497 83.281 49.0002 83.1871 49.3326L81.6465 49.3315C81.6865 48.9959 81.7082 48.646 81.7083 48.2859C81.7086 47.9205 81.6869 47.5649 81.646 47.2249ZM82.9331 46.576L81.5426 46.5747C81.3873 45.8085 81.1297 45.1473 80.8048 44.6605C81.7346 45.0032 82.4969 45.6948 82.9331 46.576ZM78.1346 44.6624C77.8098 45.1484 77.5533 45.8078 77.3965 46.5715L76.0137 46.5703C76.4498 45.6942 77.2091 45.0057 78.1346 44.6624ZM76.0034 49.9771L77.3908 49.9779C77.5457 50.7487 77.8029 51.413 78.1289 51.9028C77.1988 51.557 76.4368 50.8616 76.0034 49.9771ZM80.7984 51.9101C81.1267 51.4207 81.3856 50.7542 81.5422 49.9813L82.938 49.9821C82.5016 50.8696 81.7347 51.5666 80.7984 51.9101Z' fill='%23EFEFEF'/%3E%3Cpath d='M141.25 87.5C139.455 87.5 138 88.9551 138 90.75V101.25C138 103.045 139.455 104.5 141.25 104.5H150.75C152.545 104.5 154 103.045 154 101.25V90.75C154 88.9551 152.545 87.5 150.75 87.5H141.25ZM159.123 102.643L155.5 99.0935V92.9989L159.112 89.3706C159.899 88.5804 161.248 89.1375 161.248 90.2525V101.75C161.248 102.858 159.914 103.418 159.123 102.643Z' fill='%232B88D8'/%3E%3Cpath d='M213.402 122.963H84.8701V127.473H213.402V122.963Z' fill='%232B88D8'/%3E%3Cg filter='url(%23filter1_d_725_95734)'%3E%3Cpath d='M42.7781 51.5561C49.8352 51.5561 55.5561 45.8352 55.5561 38.7781C55.5561 31.7209 49.8352 26 42.7781 26C35.7209 26 30 31.7209 30 38.7781C30 45.8352 35.7209 51.5561 42.7781 51.5561Z' fill='%23E1DFDD'/%3E%3C/g%3E%3Cg filter='url(%23filter2_d_725_95734)'%3E%3Cpath d='M241.89 174C247.702 174 252.413 169.289 252.413 163.477C252.413 157.665 247.702 152.954 241.89 152.954C236.079 152.954 231.367 157.665 231.367 163.477C231.367 169.289 236.079 174 241.89 174Z' fill='%23E1DFDD'/%3E%3C/g%3E%3Cg filter='url(%23filter3_d_725_95734)'%3E%3Cpath d='M229.188 166.559C234.169 166.559 238.208 162.52 238.208 157.539C238.208 152.557 234.169 148.519 229.188 148.519C224.206 148.519 220.168 152.557 220.168 157.539C220.168 162.52 224.206 166.559 229.188 166.559Z' fill='%23E1DFDD'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_725_95734' x='36.8311' y='11.2748' width='224.611' height='159.97' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='4'/%3E%3CfeGaussianBlur stdDeviation='15'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_725_95734'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_725_95734' result='shape'/%3E%3C/filter%3E%3Cfilter id='filter1_d_725_95734' x='0' y='0' width='85.5557' height='85.5562' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='4'/%3E%3CfeGaussianBlur stdDeviation='15'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_725_95734'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_725_95734' result='shape'/%3E%3C/filter%3E%3Cfilter id='filter2_d_725_95734' x='201.367' y='126.954' width='81.0459' height='81.0463' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='4'/%3E%3CfeGaussianBlur stdDeviation='15'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_725_95734'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_725_95734' result='shape'/%3E%3C/filter%3E%3Cfilter id='filter3_d_725_95734' x='190.168' y='122.519' width='78.04' height='78.0397' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='4'/%3E%3CfeGaussianBlur stdDeviation='15'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_725_95734'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_725_95734' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E";


export const AddVideoPanelContent = (props) => {
  const { i18n, onChange } = props;
  const classes = useStyles();
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [processedUrl, setProcessedUrl] = useState('');
  const [messageBarText, setMessageBarText] = useState('');
  const [cachedUrl, setCachedUrl] = useState('');
  const [urlInputErrors, setUrlInputErrors] = useState([]);
  const [videoLoadStarted, setVideoLoadStarted] = useState(false);

  const handleInput = useCallback(() => {
    if (cachedUrl !== processedUrl) {
      setProcessedUrl(cachedUrl);
      setMessageBarText('');

      if (isEmpty(urlInputErrors)) {
        onChange([{ url: cachedUrl }]);
        setVideoLoadStarted(true);
      } else {
        setVideoLoadStarted(false);
      }
    }
  }, [cachedUrl, onChange, processedUrl, urlInputErrors]);

  const onUrlInputChange = useCallback((event, data) => {
    const { value } = data || {};
    setCachedUrl(value);

    const errors = [];

    if (!isValidUrl(value)) {
      errors.push(i18n.getString(_TL_('Please enter a valid URL.')));
    }

    if (_.size(value) > UrlInputMaxLen) {
      errors.push(i18n.getString(
        _TL_('The URL you entered is too long. Please enter a different URL. Max. URL length: {{max}} characters.'),
        { max: UrlInputMaxLen }
      ));
    }

    setUrlInputErrors(errors);
  }, [i18n]);

  const onKeyDown = useCallback((ev) => {
    if (ev.keyCode === EnterKeycode) {
      handleInput();
    }
  }, [handleInput]);

  const onBlur = useCallback(() => {
    handleInput();
  }, [handleInput]);

  const onErrorHandler = useCallback(() => {
    setMessageBarText(i18n.getString(_TL_('A preview of your video cannot be displayed. Please confirm that your video\'s URL is supported or upload your video file directly into Asset library.')));
  }, [i18n]);

  const onLoadedMetadata = useCallback(() => {
    setVideoLoaded(true);
  }, []);

  return (
    <div className={classnames(`url-video-view ${classes.container}`)}>
      <div className="tip">
        { videoLoaded
          ? <div> {i18n.getString(_TL_('We found this video from your URL'))} </div>
          : (
            <div>
              {i18n.getString(_TL_("Please enter your video's URL."))}
              <button className={classnames(`HelpTopic ${classes.helpLink}`)} query="help:app54863">{i18n.getString(_TL_('Learn more about video source requirements.'))}</button>
            </div>
          )
        }
      </div>
      <Input
        className={classnames('add-url', classes.addUrlInput)}
        // styles={styles.placeholderTextFieldStyles}
        value={cachedUrl}
        onChange={onUrlInputChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        placeholder={i18n.getString(_TL_('Enter video URL'))}
        contentBefore={<SearchFilled />}
      />
      <div aria-live="polite">
        {!_.isEmpty(urlInputErrors) &&
          <div className={classnames('error-msg', classes.errorMesBelowUrlInput)}>
            {urlInputErrors.map(err => <div key={err}>{err}</div>)}
          </div>
        }
      </div>

      { videoLoadStarted
        ? <VideoLoadPreview
            i18n={i18n}
            url={processedUrl}
            onLoadedMetadata={onLoadedMetadata}
            onErrorHandler={onErrorHandler}
        />
        : <img className={classes.placeHolderImage} src={placeholderImage} alt="" />
      }

      { messageBarText &&
        <MessageBar intent="warning" className={classes.messageContainer}>
          {messageBarText}
        </MessageBar>
      }
    </div>
  );
};

AddVideoPanelContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
